import { ICartData, IFrontConfiguratorProduct, IFrontConfiguratorImages } from '@features/cart/typescript';
const productFrontAdapter = (configuratorData: IFrontConfiguratorProduct, images: IFrontConfiguratorImages, productCartQuantity = 0): {
  products: ICartData[];
  maxQuantityReached: boolean;
} => {
  const products = configuratorData.data.cartData.products.map(product => ({
    ...product
  }));
  const mainProduct = products[0];
  if (mainProduct?.maxQuantity != null && mainProduct.maxQuantity > 0) {
    const availableToAdd = mainProduct.maxQuantity - productCartQuantity;
    const exceedsAvailableQuantity = availableToAdd <= 0 || mainProduct.quantity > availableToAdd;
    if (exceedsAvailableQuantity) {
      return {
        products: [],
        maxQuantityReached: true
      };
    }
  }
  if (images.dedicated) {
    products.forEach((product, index) => {
      products[index] = {
        ...product,
        image: images.dedicated
      };
    });
  }
  return {
    products,
    maxQuantityReached: false
  };
};
export default productFrontAdapter;